export interface iTracking {
    interaction_name?: 'tab_clicked';
    element_name?: string; 
    element_order?: number;
    filter_value?: string;
    widget_order?: number;
}

const mapTitleKeyToElementName = (titleKey: string): string => {
    const mapping: Record<string, string> = {
        'InHouseStats.TabStats': 'stats',
        'InHouseStats.TabOverview': 'overview',
        'InHouseStats.TabPlayers': 'players',
        'InHouseStats.TabLineups': 'lineup',
        'InHouseStats.TabH2H': 'h2h'
    };
    return mapping[titleKey] || titleKey;
}

export const trackInteraction = (tracking: iTracking) => {
    const widgetData = {
        interaction_name: tracking.interaction_name || null,
        name: 'in_house_stats',
        filter_value: tracking.filter_value || '',
        content_placement: 'stream_player',
        widget_order: tracking.widget_order !== undefined ? tracking.widget_order : 1,
        element_name: tracking.element_name || null,
        element_order: tracking.element_order !== undefined ? tracking.element_order : null,
        page_type: 'sports_event_details_page'
    };

    const message = {
        type: 'kspEvent',
        data: widgetData
    };

    window.parent.postMessage(message, '*');
};

export { mapTitleKeyToElementName };